import type {SVGProps} from 'react'

const SvgCo2Large = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={24}
    height={24}
    fill={'none'}
    viewBox={'0 0 48 48'}
    {...props}
  >
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M17 10.6c-6.284 0-11.477 4.675-12.29 10.736l-.024.186-.127.14A9.36 9.36 0 0 0 2.099 28a9.4 9.4 0 0 0 9.4 9.4h16a8.4 8.4 0 0 0 2.068-16.544l-.362-.091-.078-.366C27.932 14.8 22.956 10.6 17 10.6M3.547 20.992C4.518 14.432 10.171 9.4 17 9.4c6.406 0 11.776 4.429 13.219 10.39 3.977 1.173 6.88 4.852 6.88 9.21a9.6 9.6 0 0 1-9.6 9.6h-16C5.647 38.6.9 33.854.9 28c0-2.686 1.001-5.14 2.648-7.008'}
      clipRule={'evenodd'}
    />
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M16.386 24a2.6 2.6 0 0 1 2.6-2.6h.658a2.6 2.6 0 0 1 2.6 2.6v2.986a2.6 2.6 0 0 1-2.6 2.6h-.658a2.6 2.6 0 0 1-2.6-2.6zm2.6-1.4a1.4 1.4 0 0 0-1.4 1.4v2.986a1.4 1.4 0 0 0 1.4 1.4h.658a1.4 1.4 0 0 0 1.4-1.4V24a1.4 1.4 0 0 0-1.4-1.4zM25.07 27.193a.795.795 0 0 0-.795.795v.067h-1.07v-.067c0-1.03.835-1.866 1.865-1.866 1.685 0 2.506 2.056 1.286 3.217l-2.434 2.082-.648-.637 2.344-2.22c.52-.495.17-1.37-.548-1.37M9.4 24a2.6 2.6 0 0 1 2.6-2.6h.91a2.347 2.347 0 0 1 2.347 2.347h-1.2c0-.634-.513-1.147-1.146-1.147H12a1.4 1.4 0 0 0-1.4 1.4v2.986a1.4 1.4 0 0 0 1.4 1.4h.91c.634 0 1.147-.513 1.147-1.146h1.2a2.347 2.347 0 0 1-2.346 2.346H12a2.6 2.6 0 0 1-2.6-2.6z'}
      clipRule={'evenodd'}
    />
    <path
      fill={'currentColor'}
      fillRule={'evenodd'}
      d={'M26.996 31.805H23.27V30.78h3.726z'}
      clipRule={'evenodd'}
    />
  </svg>
)
export default SvgCo2Large
